/**
 * @generated SignedSource<<f71f4408d1068bddb46758e4ae198ef1>>
 * @relayHash 0364ebf04a149c5cd5b923316a2324ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 67130027b1ddb3aab997061035952a486c3519596e6aaf454bc81d9896725845

import type { ConcreteRequest } from 'relay-runtime';
export type premiumBenefitsModalQuery$variables = {
  cloudId: string;
  hamsProductKey: string;
};
export type premiumBenefitsModalQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null;
            readonly isAvailableToUser: boolean | null;
          } | null;
        } | null;
        readonly relatesFromEntitlements: ReadonlyArray<{
          readonly entitlementId: string | null;
          readonly relationshipType: string | null;
        } | null> | null;
      } | null;
    } | null;
  } | null> | null;
};
export type premiumBenefitsModalQuery = {
  response: premiumBenefitsModalQuery$data;
  variables: premiumBenefitsModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hamsProductKey"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "hamsProductKey"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "offeringName",
    "value": "Premium"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v5 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v6 = {
  "kind": "ScalarField",
  "name": "relationshipType"
},
v7 = {
  "kind": "ScalarField",
  "name": "entitlementId"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "premiumBenefitsModalQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v3/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "relatesFromEntitlements",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "premiumBenefitsModalQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "args": (v3/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "relatesFromEntitlements",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "67130027b1ddb3aab997061035952a486c3519596e6aaf454bc81d9896725845",
    "metadata": {},
    "name": "premiumBenefitsModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0854408facd8d9c64a16089df4b3226a";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
